import customerApi from "../../utils/customer-api";
import { InvoiceInfoBillWrapper, Response } from "../../types/types";


export const getCustomerInvoices = async(): Promise<Response<InvoiceInfoBillWrapper>> => {
  const res = await customerApi.get<never, Response<InvoiceInfoBillWrapper>>(`/self_customer/invoices`);
  if (res.status === 200) {
    return res
  } else {
    console.error(res);
    throw res
  }
}
